<template>
	<v-card class="mt-3 ma-2">
		<possible-tags :possible-tags="possibleTags"/>
		<v-toolbar :color="color" dark>
			<v-toolbar-title>{{ header }}</v-toolbar-title>
			<v-spacer></v-spacer>
			<v-btn @click="$refs.fileInput.click()" icon>
				<v-icon>add</v-icon>
			</v-btn>

			<input @change="uploadFile" ref="fileInput" id="fileInput" type="file" v-show="false" accept=".rtf">
		</v-toolbar>

		<v-list two-line>
			<template v-for="(item, index) in contractTemplates">
				<v-list-tile :key="item.id" avatar>
					<v-list-tile-avatar>
						<v-icon>assignment</v-icon>
					</v-list-tile-avatar>

					<v-list-tile-content>
						<v-list-tile-title v-html="item.fileName"></v-list-tile-title>
						<v-list-tile-sub-title v-html="displayDateTime(item.creationDate)"></v-list-tile-sub-title>
						<v-list-tile-action-text v-html="getContractFileUrl(item.id)"></v-list-tile-action-text>
					</v-list-tile-content>

					<v-list-tile-action>
						<v-btn @click="downloadFile(item)" icon ripple>
							<v-icon color="primary">cloud_download</v-icon>
						</v-btn>
					</v-list-tile-action>

					<v-list-tile-action>
						<v-btn @click="deleteFile(item, index)" icon ripple>
							<v-icon color="lightred">delete</v-icon>
						</v-btn>
					</v-list-tile-action>
				</v-list-tile>
			</template>
		</v-list>
	</v-card>
</template>

<script>
	import {Dates} from "../../../utils/Dates";
	import {Files} from "../../../utils/Files";
	import {Api} from "../../../api";
	import {Contract} from "../../../api/generated/Contract";
	import PossibleTags from "./PossibleTags";

	export default {
		name: "ContractTemplatesList",
		components: {PossibleTags},
		data() {
			return {};
		},

		props: {
			color: String,
			header: String,
			contractTemplateType: String,
			contractTemplates: Array,
			possibleTags: Array
		},

		methods: {
			downloadFile(file) {
				this.downloadContractTemplateFile(this, file.id, file.fileName);
			},

			deleteFile(file, index) {
				Contract.delete(this, file.id,
					successResponse => {
						this.$delete(this.contractTemplates, index);
						this.$messagesBus.$emit("success", "Dokument został pomyślnie usunięty", successResponse);
					},
					errorResponse => {
						this.$messagesBus.$emit("error", "Nie udało się poprawnie usunąć dokumentu", errorResponse);
					});
			},

			async uploadFile() {
				let validFilesSize = await Files.methods.validateFilesSize(this, this.$refs.fileInput.files);
				if (!validFilesSize) {
					Files.methods.clearFileInput('fileInput');
					return;
				}
        if (this.hasNonRtfFileExtension(this.$refs.fileInput.files)) {
          Files.methods.clearFileInput('fileInput');
          this.$messagesBus.$emit("error", "Dozwolone jest tylko wgranie pojedynczego pliku w formacie .rtf");
          return;
        }
				Api.postMultipart(this, "/contract?departmentId=" + this.$route.params.departmentId, this.$refs.fileInput.files[0], this.contractTemplateType,
					successResponse => {
						this.contractTemplates.push(successResponse);
            Files.methods.clearFileInput('fileInput');
						this.$messagesBus.$emit("success", "Dokument został pomyślnie dodany", successResponse);
					},
					errorResponse => {
            Files.methods.clearFileInput('fileInput');
						this.$messagesBus.$emit("error", "Nie udało się poprawnie dodać dokumentu", errorResponse);
					});
			},
		},

		mixins: [
			Dates,
			Files,
		],
	};
</script>

<style scoped>

</style>
